export const buildUrl = (language, pathName = "") => {
  if (pathName && !pathName.startsWith("/")) {
    pathName = "/" + pathName;
  }
  const _finalPath = `${language.toLowerCase() === "pt" ? "" : `/${language}`}${pathName}`;
  return !_finalPath ? "/" : _finalPath;
};
